module.exports = __webpack_public_path__ + "static/img/zngk_p5.4e9267d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/zngk_p5.png
// module id = J+v/
// module chunks = 19